<template>
  <div class="burger-menu">
    <div @click="toggleClick"
         :class="{active:show}" class="burger">
      <div class="item"></div>
      <div class="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },

  methods: {
    toggleClick() {
      this.show = !this.show
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.burger-menu {
  display: none;
  @media only screen and (max-width: 1023px) {
    display: block;
  }

  .burger {
    width: 25px;

    .item {
      width: 100%;
      height: 2px;
      background: white;
      position: relative;
      transition: transform .4s ease-out;

      &:last-child {
        margin-top: 8px;
      }
    }

    &.active {
      .item:nth-child(1) {
        transform: translateY(-50%) rotate(45deg);
      }

      .item:nth-child(2) {
        transform: translateY(-50%) rotate(-45deg);
        margin-top: 0;
      }
    }
  }

}
</style>